import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { userMessage } from '../../../../utils/vy-toasts';
import { isError } from '@vy/utils';
import type { XeroExportInvoicesRequestPayload } from '@vy/api-definition';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useXeroExportInvoices(
  options?: UseMutationOptions<void, unknown, XeroExportInvoicesRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['xeroExportInvoices'],
    mutationFn: async ({ invoiceIds }) => {
      const api = getPrivateApi();

      return api.xeroExportInvoices({
        xeroExportInvoicesRequest: {
          invoiceIds,
        },
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.jobs());
    },
    onError: (error) => {
      if (isError(error)) {
        userMessage('error', error.message);
      }
    },
    ...options,
  });
}
